import NiceModal from "@ebay/nice-modal-react";
import { Icons, Modals } from "@repo/ui";
import { FC, ReactNode } from "react";
import * as Styled from "./InfoIconModalConfirm.styled";

type InfoIconModalConfirmProps = {
    title: string;
    content: ReactNode;
    buttonText?: string;
    width?: number;
};

export const InfoIconModalConfirm: FC<InfoIconModalConfirmProps> = ({ title, content, buttonText, width = 480 }) => {
    const openModal = () => {
        NiceModal.show(Modals.ModalConfirm, {
            width: width,
            title: title,
            buttonText: buttonText,
            content: () => <>{content}</>,
        });
    };

    return (
        <Styled.RoundIconButton disableRipple onClick={openModal}>
            <Icons.Info />
        </Styled.RoundIconButton>
    );
};
